import { z } from "zod";

/**
 * Type-safe JSON parse with Zod validation
 */
export function parseJSON<T>(json: string, schema: z.ZodSchema<T>): T | null {
  try {
    const parsed = JSON.parse(json);
    const result = schema.safeParse(parsed);

    if (!result.success) {
      console.error("JSON validation failed:", result.error);
      return null;
    }

    return result.data;
  } catch (error) {
    console.error("JSON parse failed:", error);
    return null;
  }
}

/**
 * Type-safe JSON stringify with validation
 */
export function stringifyJSON<T>(
  data: T,
  schema: z.ZodSchema<T>,
): string | null {
  const result = schema.safeParse(data);

  if (!result.success) {
    console.error("Data validation failed:", result.error);
    return null;
  }

  try {
    return JSON.stringify(result.data);
  } catch (error) {
    console.error("JSON stringify failed:", error);
    return null;
  }
}
